import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

export interface MeterSearchResult {
  sensorId: number;
  deviceId: string;
  address: string | null;
  consumerName: string | null;
  consumerId: string | null;
  deviceDescription: string | null;
  rate: number | null;
  flowConditions: unknown;
  sensorConditions: unknown;
  customerName: string | null;
  customerId: number | null;
}

interface MeterSearchResponse {
  meters: MeterSearchResult[];
}

export function useMeterSearch(query: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-search', query],
    queryFn: () =>
      apiClient.get<MeterSearchResponse>(
        `meters/search?q=${encodeURIComponent(query!)}`,
      ),
    enabled: !!query?.trim(),
  });
}
